import { Accordion } from '@mantine/core';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { RoundAltArrowDown } from 'solar-icons';
import { IconDiscount } from '@/Module/Icon';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import SubscriptionDiscountForm from './SubscriptionDiscountForm';
interface Props {
  id: ISubscriptionPlan['id'];
  disabled: boolean;
  onSubmit: () => void;
  controlCode: Control<any>;
  discountApplied: boolean;
  removeDiscount?: () => void;
}
const SubscriptionBuyDiscountMobile: FC<Props> = ({
  controlCode,
  onSubmit,
  disabled,
  id,
  discountApplied,
  removeDiscount
}) => {
  if (id === 182) return null;
  return <div className="lueFive relative justify-between rounded-2xl border-b-[1px] bg-white p-4 pb-3 text-base font-semibold shadow-[0px_4px_8px_-2px_rgba(0,0,0,0.10)] sm:mt-4 sm:rounded-2xl sm:p-6" data-sentry-component="SubscriptionBuyDiscountMobile" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx">
      <Accordion chevronPosition="right" chevron={<RoundAltArrowDown />} classNames={{
      control: ' rounded-2xl ',
      item: 'border-0',
      content: 'px-0 pt-0 pb-0',
      chevron: 'w-auto',
      root: '!bg-white'
    }} data-sentry-element="Accordion" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx">
        <Accordion.Item key="subscription" value="subscription" data-sentry-element="unknown" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx">
          <Accordion.Control data-sentry-element="unknown" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx">
            <div className="flex flex-row items-center">
              <IconDiscount size="small" data-sentry-element="IconDiscount" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx" />
              <div className="mr-2 w-full font-bold text-blackSix">کد تخفیف دارید!</div>
            </div>
          </Accordion.Control>
          <Accordion.Panel data-sentry-element="unknown" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx">
            <SubscriptionDiscountForm controlCode={controlCode} onSubmit={onSubmit} disabled={disabled} discountApplied={discountApplied} removeDiscount={removeDiscount} data-sentry-element="SubscriptionDiscountForm" data-sentry-source-file="SubscriptionBuyDiscountMobile.tsx" />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </div>;
};
export default SubscriptionBuyDiscountMobile;